<template>
  <div class="flex-1 flex flex-col justify-center align-center h-full absolute top-0 right-0 w-full z-50 bg-gray-900 text-white">
    <div class="text-center flex align-center items-center justify-center flex-col">
      <img src="https://tinkerwell.app/images/icon.png" class="w-32 h-32" />
      <div v-if="isSupportedBrowser">
        <h3 class="text-2xl mt-3">Tinkerwell Web is loading</h3>
        <p class="mt-1">Please wait - depending on your internet connection the initial load might take a bit...</p>
      </div>
      <div v-else>
        <h3 class="text-2xl mt-3">Unable to load Tinkerwell Web</h3>
        <p class="mt-1">Sorry, but your browser is currently not supported for Tinkerwell Web.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';

export default {
  name: 'PhpLoading',
  components: {
    Spinner,
  },
  data() {
    return {
      isSupportedBrowser: window.isSupportedBrowser,
    };
  },
  mounted() {
    
  },
  methods: {
    progress({loaded, total}) {
      this.progress = Math.round(loaded/total*100)+'%';
    }
  }
};
</script>

<style scoped>

</style>
